<div class="border-bottom container-fluid mw-100">
  @if (harbourDuesVisitSummary(); as summary) {
    <div class="row p-3 gx-3 main-row">
      <div class="col-auto d-none d-md-none d-lg-block d-vlg-none d-xl-block">
        @if (summary.vesselImageUrl) {
          <button class="hover-show position-relative" type="button" (click)="zoomVesselImage.emit(summary)"
            style="background-color: transparent; border-width: 0; padding: 0;">
            <img src="{{summary.vesselImageUrl}}" width="102" height="68" alt="Vessel image" class="rounded-1"/>
            <img src="/assets/new-portvisit/zoom.svg" width="30px" alt="zoom" class="to-show rounded-1 position-absolute end-0 bottom-0"/>
          </button>
        }
        @if (!summary.vesselImageUrl) {
          <img src="/assets/new-portvisit/no-vessel-image.svg" width="102" height="68" alt="Vessel image" class="rounded-1"/>
        }
      </div>
      <div class="col col-vlg-3 col-xxl-2">
        <a [href]="navigationUrl()">
          <span class="h2 text-info">
            <app-highlight [term]="term()" [result]="summary.vesselName | sentenceCase"></app-highlight>
          </span>
          <span class="h2 text-info d-none d-lg-inline"> - </span>
          <span class="h2 text-info d-none d-lg-inline"><app-highlight [term]="term()" [result]="summary.imoCode"></app-highlight></span>
        </a>
        @if (summary.cancelled) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa text-danger fa-fw fa-ban"></span>
            <span class="tooltipContent">Cancelled</span>
          </app-tooltip>
        }
        <div class="d-flex flex-row align-items-stretch">
          <div class="d-flex flex-column" style="min-width: 130px; max-width: 130px;">
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()" [result]="summary.crn"></app-highlight>
            </span>
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()" [result]="summary.arrivalVoyageNumber"></app-highlight>
            </span>
          </div>
          @if (summary.vessel) {
            <div class="d-none flex-column d-lg-flex" style="min-width: 0">
              <span class="d-inline-block text-truncate mw-100 me-2">{{summary.vessel.length | round}}
              x {{summary.vessel.width | round}} m</span>
              <span class="d-inline-block text-truncate mw-100">{{summary.vessel.grossTonnage | round}} t</span>
            </div>
          }
        </div>
      </div>
      <div class="col-3 d-none d-vlg-block col-vlg col-xxl-3">
        <app-movement-icons class="h-auto" [movements]="movements()" [term]="term()" [middleStatus]="summary.visitStatus === 'DEPARTED' ? 'departed' : summary.visitStatus === 'ARRIVED' ? 'arrived' : 'expected'"></app-movement-icons>
      </div>
      <div class="d-none d-xxl-flex align-items-center justify-content-end flex-column col-2" [style.min-width.px]="150">
        <div class="row gy-2 gx-1 mw-100">
          <div class="col-auto">
            <app-tooltip style="line-height: 1.5rem;">
              <i class="fa-light fa-user"></i>
              <span class="tooltipContent">Last edited by this user from your company</span>
            </app-tooltip>
            <div></div>
          </div>
          <div class="col d-flex flex-column" style="min-width: 0">
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()"
              [result]="summary.lastEditedByUser?.name || summary.lastEditedByUser?.orgName || 'Not available'"></app-highlight>
            </span>
            <span
            class="d-inline-block text-truncate mw-100">{{summary.lastEditedByUser ? (summary.lastEditedByUser.timestamp | date:'dd MMM HH:mm') || 'No date' : 'Not available'}}</span>
          </div>
        </div>
      </div>
      <div class="col-auto ms-auto">
        <div class="row gy-2 gx-3">
          <div class="col-auto d-flex flex-column status-column status-column-left">
            <div class="row g-0 gx-2">
              <dl class="mb-0">
                <dt class="fw-medium mb-2">BTP Status</dt>
                  <dd class="mb-2">
                    <ul class="list-unstyled mb-0">
                      @for (externalStatus of externalStatuses(); track externalStatus.statementNumber) {
                        <li>
                          <app-harbour-dues-rotterdam-external-status [externalStatus]="externalStatus.externalStatus" />
                        </li>
                      }
                    </ul>
                  </dd>
                <dt class="fw-medium mb-2">Agent Status</dt>
                  <dd class="mb-0">
                    <app-task-message-status
                      [messageStatus]="declarationStatus()"
                      [showTooltip]="false"
                    ></app-task-message-status>
                  </dd>
              </dl>
            </div>
            @if (invoices().length === 1) {
              <div class="mt-3">
                <a class="text-info text-decoration-none" style="cursor: pointer;" (click)="downloadPdf(invoices()[0])">
                  <i class="fa-light fa-download me-1"></i>
                  <span>{{ invoices()[0].invoiceNumber }} ({{ invoices()[0].invoiceType | lowercase }})</span>
                </a>
              </div>
            }
            @if (invoices().length > 1) {
              <div class="mt-3 dropdown">
                <a class="text-info text-decoration-none" style="cursor: pointer;"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span>Multiple invoices</span>
                  <i class="fa-light fa-chevron-down ms-1"></i>
                </a>
                <div class="dropdown-menu position-fixed">
                  @for (invoice of invoices(); track invoice.invoiceNumber) {
                    <button class="btn dropdown-item" (click)="downloadPdf(invoice)">
                      <i class="fa-light fa-download me-2"></i>
                      {{ invoice.invoiceNumber }} ({{ invoice.invoiceType | lowercase }})
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-auto d-flex flex-column align-items-center dropdown px-2">
        <a [href]="navigationUrl()" class="btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button" [style.margin-top.px]="-10">
          <i class="fa-light fa-fw fa-angle-right"></i>
        </a>
        <button class="btn rounded-circle p-2 text-primary h1 mt-0 action-btn-lg" type="button" [style.margin-bottom.px]="-10"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-light fa-fw fa-ellipsis-vertical"></i>
        </button>
        <div class="dropdown-menu position-fixed">
          @if (appContext.isAdmin()) {
            <button class="btn dropdown-item" (click)="tryRefreshHarbourDuesVisitSummary()">
              <i class="fa-light fa-arrows-rotate"></i>
              Refresh harbour dues summary
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
